import { updateScheduledGlobal } from "../repository/scheduled.repo";

export const UpdateScheduledGlobal = async (data) => {
  try {
    const resp = await updateScheduledGlobal(data);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
